var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":_vm.onclick}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconUrl}}),_vm._v(" "),_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c5651b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/InfoRadioItem.vue
// module id = null
// module chunks = 